import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<boolean | null>(null)
